import {isFunction, isString} from "../../../__snowpack__/pkg/lodash.js";
import {LoadingOutlined, WarningFilled} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import React from "../../../__snowpack__/pkg/react.js";
export const formatUnit = (maxSize) => {
  let level = 0;
  let rest = maxSize;
  while (rest >= 1024) {
    rest /= 1024;
    level += 1;
  }
  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  return rest + units[level];
};
export class InvalidResolutionError extends Error {
  constructor(message, type) {
    super(message);
    this.type = type;
  }
}
export const checkResolution = (file, config) => new Promise((resolve, reject) => {
  const {minWidth = 0, maxWidth, minHeight = 0, maxHeight, ratio, errorMessage} = config;
  const img = new Image();
  img.onload = () => {
    if (minWidth && img.width < minWidth || maxWidth && img.width > maxWidth || minHeight && img.height < minHeight || maxHeight && img.height > maxHeight) {
      const _errorMessage = isFunction(errorMessage) ? errorMessage("range") : errorMessage;
      reject(new InvalidResolutionError(_errorMessage, "range"));
    }
    let _ratio = ratio;
    if (isString(ratio)) {
      if (!/^\d+:\d+$/.test(ratio)) {
        _ratio = void 0;
        console.error("resolution.ratio\u4E3A\u5B57\u7B26\u4E32\u65F6, \u5E94\u6EE1\u8DB3\u683C\u5F0F /^d+:d+$/");
        return;
      }
      const [w, h] = ratio.split(":");
      _ratio = Number(w) / Number(h);
    }
    if (_ratio && _ratio !== img.width / img.height) {
      const _errorMessage = isFunction(errorMessage) ? errorMessage("ratio") : errorMessage;
      reject(new InvalidResolutionError(_errorMessage, "ratio"));
    }
    resolve(file);
  };
  img.onerror = (error) => {
    reject(error);
  };
  img.src = (window.URL || window.webkitURL).createObjectURL(file);
});
export const transferFileList = (fileList, dataShape) => {
  if (dataShape === "URL-array") {
    return fileList?.map((url, i) => ({
      uid: `-${i}`,
      name: url,
      url,
      thumbUrl: url,
      status: "success"
    }));
  }
  return fileList?.map((file, i) => {
    let data;
    Object.entries(dataShape).forEach(([originKey, targetKey]) => {
      data ??= {};
      data[originKey] = file[targetKey];
    });
    return {
      ...data,
      uid: dataShape.uid ? file[dataShape.uid] : `-${i}`,
      name: file[dataShape.name || dataShape.url] || "",
      url: file[dataShape.url] || "",
      thumbUrl: file[dataShape.thumbUrl || dataShape.url || ""],
      status: "success"
    };
  });
};
export const transferUploadFileArray = (internalFileList, dataShape) => {
  const newFileList = Object.defineProperties([], {
    __internalFileList__: {writable: false, value: internalFileList},
    hasError: {writable: true, value: false},
    uploading: {writable: true, value: false}
  });
  internalFileList.filter(({status}) => {
    if (status === "error") {
      newFileList["hasError"] = true;
    }
    if (status === "uploading") {
      newFileList["uploading"] = true;
    }
    return status === "done" || status === "success";
  }).forEach((_file) => {
    let newFile;
    if (dataShape === "URL-array") {
      newFile = _file.url;
    } else {
      Object.entries(dataShape).forEach(([key, targetKey]) => {
        newFile ??= {};
        newFile[targetKey] = _file[key];
      });
    }
    newFileList.push(newFile);
  });
  return newFileList;
};
export const basicFormRule = () => {
  return {
    validator: (rule, value) => {
      if (Array.isArray(value) && value.uploading) {
        return Promise.reject(React.createElement(LoadingOutlined, {style: {color: "#0000FF80"}}));
      }
      if (Array.isArray(value) && value.hasError) {
        return Promise.reject(React.createElement(WarningFilled, {style: {fontSize: 14, color: "red"}}));
      }
      return Promise.resolve();
    }
  };
};
